module.exports = __webpack_public_path__ + "static/media/gc-waiting.91c5b67d.svg";